/* eslint-disable @typescript-eslint/no-explicit-any */
// Github issue and the solution that is used: https://github.com/slab/quill/issues/4535#issuecomment-2874963898
import Quill from "quill";

(function installNbspFix() {
  // Get the original method that *every* Quill instance inherits
  const original = (Quill as any).prototype.getSemanticHTML;

  // ugly patch to fix the issue with &nbsp; in Quill
  (Quill as any).prototype.getSemanticHTML = function (
    this: Quill, // explicit `this` for TS strict‑mode
    index = 0,
    length?: number,
  ): string {
    const len = length ?? this.getLength();
    const html = original.call(this, index, len);
    return html.replaceAll(/&nbsp;|\u00A0/g, " ").replaceAll(/<p><\/p>/g, "<br>");
  };
})();
